// removed by extract-text-webpack-plugin
module.exports = {"block":"src-components-Header----header-module---block---2Uvvl","name":"src-components-Header----header-module---name---1vTUC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.sass
// module id = 358
// module chunks = 114276838955818